import { call, put, takeEvery } from "redux-saga/effects";
import {
  assignFoldersFail,
  assignFoldersSuccess,
  createFolderFail,
  createFolderSuccess,
  deleteFolderFail,
  deleteFolderFilesFail,
  deleteFolderFilesSuccess,
  deleteFolderSuccess,
  getAssignedMembersFail,
  getAssignedMembersSuccess,
  getFoldersFail,
  getFoldersFileFail,
  getFoldersFileSuccess,
  getFoldersSuccess,
  removeFolderUserFail,
  removeFolderUserSuccess,
  renameFolderFail,
  renameFolderSuccess,
  updateFolderPermissionFail,
  updateFolderPermissionSuccess,
} from "./action";
import showToast from "common/Notification";
import {
  ADD_FILE_TO_FOLDER,
  ASSIGN_FOLDERS,
  CREATE_FOLDER,
  DELETE_FOLDER,
  DELETE_FOLDER_FILES,
  GET_ASSIGNED_MEMBERS,
  GET_FOLDERS,
  GET_FOLDER_FILES,
  REMOVE_FOLDER_USER,
  RENAME_FOLDER,
  UPDATE_FOLDER_PERMISSION,
} from "./actionTypes";
import {
  onFecthFolders,
  onCreatingFolder,
  onFecthFiles,
  onAddingFileToFolder,
  onDeleteFolderFiles,
  onAssignFolders,
  onAssignedMembersFetch,
  onUpdatingFolderPermission,
  onRemovingFolderUser,
  onDeleteFolder,
  onRenamingFolder,
} from "helpers/fakebackend_helper";
import { responseHandler } from "common/CommanFunction";

function* UpdatingFolderPermission({ payload: data }) {
  try {
    const response = yield call(onUpdatingFolderPermission, data);
    if (response.status) {
      yield put(updateFolderPermissionSuccess(response));
      showToast("success", "Private Folder", response.message);
    } else {
      yield put(updateFolderPermissionFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(updateFolderPermissionFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* onRenameFolder({ payload: data }) {
  try {
    const response = yield call(onRenamingFolder, data);
    if (response.status) {
      yield put(renameFolderSuccess(response));
      showToast("success", "Private Folder", response.message);
    } else {
      yield put(renameFolderFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(renameFolderFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* RemovingFolderUser({ payload: data }) {
  try {
    const response = yield call(onRemovingFolderUser, data);
    if (response.status) {
      yield put(removeFolderUserSuccess(response));
    } else {
      yield put(removeFolderUserFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(removeFolderUserFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* fetchFolders({ payload: data }) {
  try {
    const response = yield call(onFecthFolders, data);
    if (response.status) {
      yield put(getFoldersSuccess(response));
    } else {
      yield put(getFoldersFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(getFoldersFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* fetchFiles({ payload: data }) {
  try {
    const response = yield call(onFecthFiles, data);
    if (response.status) {
      yield put(getFoldersFileSuccess(response));
    } else {
      yield put(getFoldersFileSuccess(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(getFoldersFileFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* postAddFile({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingFileToFolder, data);
    yield call(responseHandler, "Private Folder", response, createFolderSuccess, createFolderFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(createFolderFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* postCreateFolder({ payload: data }) {
  try {
    const response = yield call(onCreatingFolder, data);
    if (response.status) {
      yield put(createFolderSuccess(response));
    } else {
      yield put(createFolderFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(getFoldersFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* postDeleteFolder({ payload: data }) {
  try {
    const response = yield call(onDeleteFolder, data);
    if (response.status) {
      yield put(deleteFolderSuccess(response));
      showToast("success", "Private Folder", response.message);
    } else {
      yield put(deleteFolderFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(deleteFolderFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* postDeleteFiles({ payload: data }) {
  try {
    const response = yield call(onDeleteFolderFiles, data);
    if (response.status) {
      yield put(deleteFolderFilesSuccess(response));
      showToast("success", "Private Folder", response.message);
    } else {
      yield put(deleteFolderFilesFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(deleteFolderFilesFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* postAssignFolders({ payload: data }) {
  try {
    const response = yield call(onAssignFolders, data);
    if (response.status) {
      yield put(assignFoldersSuccess(response));
      showToast("success", "Private Folder", response.message);
    } else {
      yield put(assignFoldersFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(deleteFolderFilesFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* fetchAssignedMembers({ payload: data }) {
  try {
    const response = yield call(onAssignedMembersFetch, data);
    if (response.status) {
      yield put(getAssignedMembersSuccess(response));
    } else {
      yield put(getAssignedMembersFail(response));
      showToast("warning", "Private Folder", response.message);
    }
  } catch (error) {
    yield put(getAssignedMembersFail(error));
    showToast("error", "Private Folder", error);
  }
}

function* fileMangerSaga() {
  yield takeEvery(GET_FOLDERS, fetchFolders);
  yield takeEvery(CREATE_FOLDER, postCreateFolder);
  yield takeEvery(GET_FOLDER_FILES, fetchFiles);
  yield takeEvery(ADD_FILE_TO_FOLDER, postAddFile);
  yield takeEvery(DELETE_FOLDER_FILES, postDeleteFiles);
  yield takeEvery(DELETE_FOLDER, postDeleteFolder);
  yield takeEvery(ASSIGN_FOLDERS, postAssignFolders);
  yield takeEvery(GET_ASSIGNED_MEMBERS, fetchAssignedMembers);
  yield takeEvery(UPDATE_FOLDER_PERMISSION, UpdatingFolderPermission);
  yield takeEvery(REMOVE_FOLDER_USER, RemovingFolderUser);
  yield takeEvery(RENAME_FOLDER, onRenameFolder);
}

export default fileMangerSaga;
